import { api } from "@/utils/axios";

export const depotService = {
  reduction_order_parts_together(body: any) {
    return api.post("/Depot/reduction_order_parts_together", body);
  }
};
